import { HttpClient } from 'Mri.Web.Common';

export class AdminStore {
    public constructor(httpClient: HttpClient) {
        this.httpClient = httpClient;
    }

    public async refresh(type: 'orleans' | 'helpcenter' | 'zendesk' | 'shipdates' | 'contracts' | 'release' | 'init') {
        await this.httpClient.post('/api/v1/admin/refresh', undefined, {
            params: {
                type,
            },
        });
    }

    public async syncSoftwareVersions() {
        await this.httpClient.post('/api/v1/admin/sync-software-versions');
    }

    public async enableKicks(serialNumbers: string[]) {
        await this.httpClient.put('/api/v1/displays/enable-web-api-kick', serialNumbers);
    }

    public async disableKicks(serialNumbers: string[]) {
        await this.httpClient.put('/api/v1/displays/disable-web-api-kick', serialNumbers);
    }

    private readonly httpClient: HttpClient;
}
